import { render } from "./AddPartenairePage.vue?vue&type=template&id=2936addb&ts=true"
import script from "./AddPartenairePage.vue?vue&type=script&lang=ts"
export * from "./AddPartenairePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__